import { toast } from 'sonner';
import i18next from 'i18next';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class CrisisRecoveryActivityIntegration {
    constructor(service) {
        this.service = service;
    }

    async fetchAll(params = {}) {
        try {
            const response = await this.service.getAll(params);
            return { success: true, data: response.data || [], pagination: response.pagination || {} };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, data: [] };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('bcmCrisisEvent:messages.recoveryActivity.createSuccess', { defaultValue: 'Crisis recovery activity created successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('bcmCrisisEvent:messages.recoveryActivity.updateSuccess', { defaultValue: 'Crisis recovery activity updated successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async delete(id) {
        try {
            const response = await this.service.delete(id);
            toast.success(i18next.t('bcmCrisisEvent:messages.recoveryActivity.deleteSuccess', { defaultValue: 'Crisis recovery activity deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async batchDelete(ids) {
        try {
            const response = await this.service.batchDelete(ids);
            toast.success(i18next.t('bcmCrisisEvent:messages.recoveryActivity.bulkDeleteSuccess', { defaultValue: 'Crisis recovery activities deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }
}
